module.exports = require("./shi-Latn");